import React from 'react';
import { BASELINE_MODES } from '../../utils/watchlistBaseline';

/**
 * Shared pill toggle that picks the baseline for simulated returns.
 *
 *   mode      'avg_cost' | 'current'
 *   onChange  (next) => void
 *   size      'sm' (compact — card header) | 'md' (filter row / heatmap settings)
 *   showLabel bool — render the "Compare to:" lead-in (default: false)
 *
 * State lives on `Watchlist.js` and is prop-drilled; this component is purely
 * presentational. Multiple render points (filter row, heatmap settings, card
 * header) all share the same state.
 */
export default function BaselineToggle({ mode, onChange, size = 'md', showLabel = false }) {
  if (!onChange) return null;
  const isAvg = mode === BASELINE_MODES.AVG_COST;
  const compact = size === 'sm';

  const btnStyle = (selected) => ({
    padding: compact ? '4px 10px' : '6px 14px',
    borderRadius: '999px',
    fontWeight: 600,
    fontSize: compact ? '11px' : '12px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
    background: selected ? '#218aff' : 'transparent',
    color: selected ? '#fff' : '#9ca3af',
    border: selected ? '1px solid #218aff' : '1px solid #333',
  });

  return (
    <div className="flex items-center gap-1" style={{ gap: '6px' }}>
      {showLabel && (
        <span style={{ fontSize: compact ? '11px' : '12px', color: '#9ca3af', fontWeight: 600 }}>
          Compare to:
        </span>
      )}
      <button
        type="button"
        onClick={() => onChange(BASELINE_MODES.AVG_COST)}
        style={btnStyle(isAvg)}
        title="Compare simulated returns to your avg cost per contract"
      >
        Avg Cost
      </button>
      <button
        type="button"
        onClick={() => onChange(BASELINE_MODES.CURRENT)}
        style={btnStyle(!isAvg)}
        title="Compare simulated returns to today's market premium"
      >
        {compact ? 'Current' : 'Current Premium'}
      </button>
    </div>
  );
}
